"use client";

import { ArrowUpRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ServicesList() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const services = [{
    code: "KATEGORI / 01",
    title: "Berita Terkini",
    description: "Liputan mendalam mengenai peristiwa nasional dan lokal yang sedang hangat diperbincangkan.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/berita_terkini_nasional.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/berita_terkini_nasional.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/berita_terkini_nasional.png-wvc-sizes",
    features: ["Update Real-time", "Sumber Terpercaya", "Analisis Tajam"]
  }, {
    code: "KATEGORI / 02",
    title: "Zona Pemuda Pancasila",
    description: "Ruang khusus informasi kegiatan, aspirasi, dan pergerakan kader Pemuda Pancasila di seluruh Indonesia.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/kegiatan_pemuda_pancasila.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/kegiatan_pemuda_pancasila.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/kegiatan_pemuda_pancasila.png-wvc-sizes",
    features: ["Info Organisasi", "Aksi Sosial", "Agenda Nasional"]
  }, {
    code: "KATEGORI / 03",
    title: "Klarifikasi & Opini",
    description: "Menyajikan fakta penyeimbang dan sudut pandang kritis terhadap isu-isu yang berkembang di masyarakat.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/klarifikasi_opini_publik.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/klarifikasi_opini_publik.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/klarifikasi_opini_publik.png-wvc-sizes",
    features: ["Hak Jawab", "Esai Kritis", "Fakta Akurat"]
  }];
  return <section data-section-id="818" id="services-list" className="relative bg-background text-foreground py-20 md:py-32 overflow-hidden">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.04]" style={{
      backgroundImage: "radial-gradient(circle, var(--foreground) 1px, transparent 1px)",
      backgroundSize: "24px 24px"
    }} />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        {}
        <div ref={headerRef} className={`grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-end mb-16 lg:mb-24 transition-all duration-700 ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="lg:col-span-7">
            <div className="font-mono text-xs tracking-[0.2em] uppercase text-muted-foreground mb-6">
              03 / Kapabilitas Media
            </div>
            <h2 className="font-default font-semibold tracking-tight text-foreground text-[2.5rem] sm:text-5xl lg:text-[4.5rem] leading-[0.95]">
              Tiga Pilar.
              <br />
              <span className="italic font-serif font-normal text-primary">Satu Integritas.</span>
            </h2>
          </div>
          <div className="lg:col-span-5 lg:pb-3">
            <p className="font-default text-base lg:text-lg text-muted-foreground leading-relaxed mb-6">
              Dari laporan investigasi hingga suara organisasi — setiap konten di Media PP 
              dikelola dengan standar jurnalistik yang ketat dan komitmen pada kebenaran.
            </p>
            <Link to="/NewsPage" className="inline-flex items-center gap-2 font-mono text-xs tracking-[0.15em] uppercase text-foreground border-b border-primary pb-1 hover:gap-3 transition-all">
              Lihat semua berita
              <span aria-hidden="true">→</span>
            </Link>
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {services.map((service, i) => <div data-index={i} key={i} className={`group border border-border bg-card flex flex-col overflow-hidden transition-all duration-500 hover:-translate-y-1 hover:shadow-lg ${i === 1 ? "md:translate-y-12" : ""}`} style={{
          aspectRatio: "auto"
        }}>
              {}
              <div className="relative w-full overflow-hidden aspect-[4/3]">
                <img src={service.image} data-wvc-srcset={service.srcset} data-wvc-sizes={service.sizes} alt={service.title} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]" />
              </div>

              {}
              <div className="flex-1 flex flex-col p-8">
                <div className="flex items-start justify-between mb-8">
                  <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-muted-foreground">
                    {service.code}
                  </span>
                  <span className="inline-flex items-center justify-center w-9 h-9 rounded-md border border-border text-primary transition-all duration-500 group-hover:translate-x-1 group-hover:-translate-y-1 group-hover:rotate-45 group-hover:border-primary">
                    <ArrowUpRight className="w-4 h-4" />
                  </span>
                </div>

                <h3 className="font-default text-2xl md:text-[28px] font-semibold tracking-tight text-foreground leading-tight mb-3">
                  {service.title}
                </h3>
                <p className="font-default text-sm text-muted-foreground leading-relaxed mb-8">
                  {service.description}
                </p>

                <ul className="mt-auto flex flex-col sm:flex-row sm:flex-wrap gap-x-5 gap-y-2 pt-6 border-t border-border">
                  {service.features.map((feature, fi) => <li data-index={fi} key={fi} className="flex items-center gap-2 font-mono text-[11px] tracking-wide uppercase text-foreground/80">
                      <span aria-hidden="true" className="inline-block w-1.5 h-1.5 rounded-md bg-primary" />
                      {feature}
                    </li>)}
                </ul>
              </div>
            </div>)}
        </div>

        {}
        <div className="mt-20 md:mt-28 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 pt-10 border-t border-border">
          <p className="font-default text-sm text-muted-foreground max-w-md">
            Punya informasi penting atau ingin memberikan klarifikasi? Kirimkan berita Anda kepada redaksi kami sekarang.
          </p>
          <Button asChild className="bg-primary text-primary-foreground hover:bg-primary/90 h-12 px-8 rounded-md font-mono text-xs tracking-[0.15em] uppercase shadow-md">
            <Link to="/SendNewsPage">
              Kirim Berita
              <ArrowUpRight className="w-4 h-4 ml-1" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}